import { Container } from "react-bootstrap";
import { ListPerfilAcesso } from "../../../Components/Configuracao/PerfilAcesso/ListPerfilAcesso";
import { ThemeContext } from "../../../context/theme-context";
import { Dispatch, SetStateAction, useContext } from "react";

export interface IListPerfilAcesso {
  title: string;
}

export interface IFormPerfilAcesso {
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  listEditeItem: any | undefined;
  setListEditeItem: Dispatch<SetStateAction<IFormPerfilAcesso | undefined>>;
}

export interface ISelectOptions {}

export default function CadPerfilAcesso() {
  const { collapsed } = useContext(ThemeContext);

  return (
    <Container
      className={collapsed ? "contenteLayoutCollapsed" : "contenteLayout"}
    >
      <ListPerfilAcesso title="Perfil de acesso" />
    </Container>
  );
}
